(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 19148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function CustomHead(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [title, " | ", "SUPERMARKET Κρητικός"]
    }), children]
  });
}

/***/ }),

/***/ 80614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Page404; }
});

// EXTERNAL MODULE: ./src/components/CustomHead.jsx
var CustomHead = __webpack_require__(19148);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./src/components/ErrorPageMain.module.scss
var ErrorPageMain_module = __webpack_require__(25561);
var ErrorPageMain_module_default = /*#__PURE__*/__webpack_require__.n(ErrorPageMain_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Error404Main.jsx





function Error404Main() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (ErrorPageMain_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ErrorPageMain_module_default()).imageContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* RiFileWarningLine */.Lze, {
        className: (ErrorPageMain_module_default()).img
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ErrorPageMain_module_default()).errorText,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "\u039B\u03C5\u03C0\u03BF\u03CD\u03BC\u03B1\u03C3\u03C4\u03B5, \u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03B4\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5."
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "/",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: (ErrorPageMain_module_default()).link,
        children: "\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B7\u03BD \u03B1\u03C1\u03C7\u03B9\u03BA\u03AE"
      })
    })]
  });
}
// EXTERNAL MODULE: ./src/components/Footer/Footer.jsx + 5 modules
var Footer = __webpack_require__(31875);
// EXTERNAL MODULE: ./src/components/Header/Header.jsx + 8 modules
var Header = __webpack_require__(3266);
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.jsx
var Navigation = __webpack_require__(86894);
;// CONCATENATED MODULE: ./src/pages/404.jsx








var __N_SSG = true;
function Page404(_ref) {
  var navigation = _ref.navigation,
      footerLinks = _ref.footerLinks;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CustomHead/* default */.Z, {
      title: "Page not found",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Page not found"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
      navigation: navigation
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
      navigation: navigation
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Error404Main, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 58671:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(80614);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25561:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPageMain_container__DBsUq","imageContainer":"ErrorPageMain_imageContainer__9Pp2T","img":"ErrorPageMain_img__iokn0","errorText":"ErrorPageMain_errorText__m9W4T","link":"ErrorPageMain_link__zriS4"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,3996,4843,9950,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(58671); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);